import React from "react";
import { Mic, MicOff, Headphones} from "react-feather";
import {  Button,UncontrolledTooltip, Spinner } from "reactstrap";
import { inject, observer } from "mobx-react";
import UserControlStore from "../../../stores/userControlStore";
enum IAudioStatus {
  NotConnected = "NOT_CONNECTED",
  Connecting = "CONNECTING",
  Connected = "CONNECTED",
  Muted = "MUTED"
}

const colors:any = {
  0: '#28c76f',
  1: '#9addf7',
  2: '#abbbf1',
  3: '#bc98eb',
  4: '#cd76ef',
  5: '#de54df',
  6: '#f6ca55',
  7: '#f35547',
  8: '#f039a0',
  9: '#ef32d9'
}
interface IUserControlsProp {
  sessionStore: any,
  userControlStore: UserControlStore,
  presenterStatus: string,
  participantAudioId: number,
  audioOpted: boolean,
  meetingId: string
}

interface IUserControlsState {
  something: any
}

@inject("userControlStore", "sessionStore")
@observer
class UserControls extends React.Component<IUserControlsProp, IUserControlsState> {

  componentDidMount(){
    const { audioOpted, userControlStore, presenterStatus } = this.props;
    const { audioStatus } = userControlStore;

    if(audioStatus !=  IAudioStatus.Connected){
      if(audioOpted && presenterStatus === 'ONLINE'){//for page refresh
        // this.joinAudio()
      }
    }
  }

  componentWillUnmount(){
    const { userControlStore} = this.props;
    // if(audioOpted){
    // userControlStore.leaveAudio(firebase, userId, meeting); 
    // }
  }

  joinAudio = () => {
    const { userControlStore, participantAudioId, meetingId } = this.props;
    // userControlStore.joinAudio(meetingId, participantAudioId);
  }

  render() {
    const { userControlStore } = this.props;
    const { audioStatus, localAudioLevel } = userControlStore;
    const micColor:string = colors[Math.floor(localAudioLevel * 10)];
    
   
    const muteControl = audioStatus === IAudioStatus.Connected || audioStatus === IAudioStatus.Connecting ? (
        <Button id="muteCall"
          outline
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="success"
          onClick={() => userControlStore.muteAudio()}
        >
          {audioStatus === IAudioStatus.Connecting  ? <Spinner size="10" /> : <Mic size={48} color={micColor} /> }
          <UncontrolledTooltip placement="top" target="muteCall">
            Mute
          </UncontrolledTooltip>
        </Button>
      ) : null;

    const unmuteControl =
      audioStatus === IAudioStatus.Muted  ? (
        <Button id="unMuteCall"
          className="mr-1 mb-1 rounded-circle btn-icon"
          color="warning"
          onClick={() => userControlStore.unMuteAudio()}
        >
          <MicOff size={48} />
          <UncontrolledTooltip placement="top" target="unMuteCall">
            Unmute
          </UncontrolledTooltip>
        </Button>
      ) : null;

      const audioControls = audioStatus !== IAudioStatus.NotConnected  ? (
        <React.Fragment>
          {muteControl}
          {unmuteControl}
        </React.Fragment>
      ) : (
            null
        );
    return (
      <React.Fragment>
          {audioControls}
      </React.Fragment>
    );
  }
}
export default UserControls;
